import { type AccommodationState, ApiActionStatus, type BasicHotelsResponse } from '@/interfaces';

export const defaultBasicHotelsResponse: BasicHotelsResponse = {
    status: ApiActionStatus.NOT_STARTED,
    attempts: 0,
    isComplete: false,
    results: [],
};

export const defaultState: AccommodationState = {
    filters: {
        starRating: {},
        guestRating: {},
        hotelChain: {},
        facility: {},
        propertyType: {},
        favoriteHotels: {},
        sort: {
            value: 'popularity',
            direction: 'descending',
        },
        rooms: [{ adults: 2, children: [] }],
        preferredHotels: [],
        hotelPageCustom: {},
    },
    searchResults: {
        status: ApiActionStatus.NOT_STARTED,
        attempts: 0,
        isComplete: false,
        results: [],
        starRatings: [],
        guestRatings: [],
        chains: [],
        facilities: [],
        propertyTypes: [],
        providers: [],
    },
    hotelPage: {
        status: ApiActionStatus.NOT_STARTED,
        attempts: 0,
        isComplete: false,
        results: [],
        images: [],
        featureSummary: [],
        features: [],
        place: {
            id: null,
            key: null,
            name: null,
            fullName: null,
            isSearchable: null,
            latitude: null,
            longitude: null,
            hierarchy: [],
            href: null,
        },
    },
    directPrices: {
        status: ApiActionStatus.NOT_STARTED,
        hotels: {},
    },
    map: {
        open: false,
        selectedHotel: {},
        hotels: [],
    },
    booking: {},
};
